<template>
  <div id="app">
    <div v-if="isHomepage">
      <router-view />
    </div>
    <div
      v-else-if="isLogin"
      :class="[isReport === true ? 'reportContent' : 'loginContent']"
    >
      <router-view />
    </div>
    <el-container v-else class="body-container">
      <el-header>
        <nav-top></nav-top>
      </el-header>
      <el-container class="content-container">
        <el-aside width="210px" :style="{ display: isCollapse }">
          <nav-left :menuData="menuConf"></nav-left>
        </el-aside>
        <el-main style="height: 100%" v-loading="loading">
          <!-- <div class="main-title">
            <span>{{mainTitle}}</span>
            <span v-if="mainTitle2">/{{mainTitle2}}</span>
          </div> -->
          <el-breadcrumb v-if="breadcrumb.length && !customizedBreadcrumb">
            <el-breadcrumb-item
              :class="'breadcrumb' + index"
              :to="getPath(item.path)"
              v-for="(item, index) of breadcrumb"
              :key="item.name"
              >{{ item.name }}</el-breadcrumb-item
            >
          </el-breadcrumb>
          <div class="main-border">
            <div class="container">
              <div v-if="isRouterAlive">
                <router-view />
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { menu, reportPlatform } from "@/conf/menu";
import NavTop from "common/components/NavTop";
import NavLeft from "common/components/NavLeft";
import { mapState, mapMutations } from "vuex";

const flags = {
  new: "新设",
  update: "变更",
  add: "迁入",
};

const customizedRouter = ["/Town/LawsDetail"];

export default {
  components: {
    NavTop,
    NavLeft,
  },

  data() {
    return {
      menuConf: [],
      breadcrumb: [],
      isRouterAlive: true,
      isLogin: false,
      isHomepage: false,
      customizedBreadcrumb: false,
      isReport: false,
      isShowReport: false,
      // mainTitle: "",
      // mainTitle2: "",
      // mainTitle3: ""
    };
  },

  computed: {
    ...mapState({
      isCollapse(state) {
        // const collapse = state.Collapse.isCollapse;
        // if (!collapse) return "none";
        return "block";
      },

      loading(state) {
        return state.Loading.loading;
      },
    }),
  },

  mounted() {
    this.setMenu();
  },

  methods: {
    getPath(path) {
      if (path)
        return {
          path,
        };
      else return "";
    },
    reload: function () {
      this.isRouterAlive = false;

      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    setMenu() {
      const code = this.Cookies.get("identifyCode");
      const registedType = this.Cookies.get("registedType");

      if (code && code.slice(0, 2) == "WR") {
        this.menuConf = reportPlatform;
        this.setTitle("公众举报平台");
      } else {
        this.setTitle("湘江私募基金管理服务平台");

        if (registedType == "GL") this.menuConf = menu;
        else this.menuConf = menu.filter((item) => item.name != "基金管理机构");
      }

      // if (code && code.slice(0, 2) == "WR") {
      //   this.menuConf = reportPlatform;
      // } else if (code && code.slice(0, 2) == "GL") {
      //   this.menuConf = menu;
      // } else {
      //   this.menuConf = menu.filter(item => item.name != "基金管理机构");
      // }
    },
    ...mapMutations(["setCollapse", "setTitle"]),
  },

  provide() {
    return {
      reload: this.reload,
    };
  },

  watch: {
    $route(route, oldRouter) {
      console.log(route.path);
      //背景图
      if (route.path === "/reportLogin/Login") {
        this.isReport = true;
        document.title = "公众举报平台";
      } else {
        this.isReport = false;
        document.title = "湘江私募基金管理服务平台";
      }
      if (oldRouter.name == "Login") {
        this.setMenu();
      }

      //主页
      if (route.path.includes("Homepage")) {
        this.isHomepage = true;
      } else {
        this.isHomepage = false;
      }
      // 登陆
      if (route.path.includes("Login")) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
      //获取当前页面主标签

      if (
        [
          "/UC/Center/UserCenter",
          "/UC/Center/CenterEdit",
          "/UC/Center/PsdEdit",
          "/UC/InfoCenter",
          "/UC/InfoDetail",
        ].includes(route.path)
      ) {
        this.setCollapse(false);
      } else {
        this.setCollapse(true);
      }

      // 特殊情况面包屑
      if (customizedRouter.includes(route.path)) {
        this.customizedBreadcrumb = true;
      } else {
        this.customizedBreadcrumb = false;
      }

      this.breadcrumb = [];
      if (["/UC/User"].includes(route.path)) return;
      if (
        !route.path.includes("ReportPlatform") &&
        !route.path.includes("Publicity")
      ) {
        if(this.menuConf ==reportPlatform){
          this.breadcrumb.push({ name: "举报平台", path: "/ReportPlatform/ReportList" });

        }else{

          this.breadcrumb.push({ name: "首页", path: "/UC" });
        }
      }

      let flag = flags[this.$route.query.flag] || "";

      route.matched.forEach((item) => {
        // 步骤的路由不需要添加
        if (!item.meta.isStep && item.meta.name)
          this.breadcrumb.push({
            name: item.meta.common ? flag + item.meta.name : item.meta.name,
            path: item.meta.path || "",
          });
      });
    },
    // "$route.path": function (to, from) {
    //   console.log(`newPath=${to},oldPath=${from}`)
    //   if (to.includes("UC")) {
    //     this.mainTitle = "首页";
    //     if (to.includes("Center")) {
    //       this.mainTitle2 = "个人中心";
    //     }
    //   }
    //   if (to.includes("FundManagemen")) {
    //     this.mainTitle = "基金管理机构";
    //   }
    //   if (to.includes("FundAgency")) {
    //     this.mainTitle = "基金机构";
    //   }
    //   if (to.includes("Audit")) {
    //     this.mainTitle = "审核进度";
    //   }
    //   if (to.includes("QuaReport")) {
    //     this.mainTitle = "季报管理";
    //   }
    //   if (to.includes("Town")) {
    //     this.mainTitle = "小镇信息";
    //   }
    //   if (to.includes("Publicity")) {
    //     this.mainTitle = "信息公示";
    //   }

    // }
  },
};
</script>


<style lang="scss" scoped>
#app {
  max-height: 100vh;
  ::v-deep .el-container {
    overflow: auto;
  }
  &::-webkit-scrollbar,
  & > *::-webkit-scrollbar {
    display: none;
  }
}
.breadcrumb0 ::v-deep  .el-breadcrumb__inner {
  color: #6ab2ff;
}
.container {
  // background: #ffffff;
  height: 100%;
  border-radius: 5px;
  // padding: 20px;
  overflow-y: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  > div {
    flex: 1;
    overflow: auto;
    .home {
      height: 100%;
    }
    > div {
      height: 100%;
    }
  }
}

.content-container {
  .el-main {
    display: flex;
    overflow: auto;
    flex-direction: column;
    .main-title {
      height: 40px;
      background: #ffffff;
      font-size: 14px;
      font-family: AlibabaM;
      text-align: left;
      color: #191818;
      line-height: 40px;
      padding-left: 26px;
    }
    .main-border {
      padding: 20px;
      background-color: #f0f0f0;
      overflow: auto;
      flex: 1;
    }
    .container {
      // background: #ffffff;
      font-size: 14px;
      font-family: AlibabaM;
      text-align: left;
      color: #191818;
      line-height: 40px;
      // padding:20px;
    }
  }
}
</style>
